var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useRef } from 'react';
import { QueryProvider } from '@sierralabs/query-ui';
import { useIframeMessageContext } from '../IframeMessageContext';
import { useSiteContext } from '../SiteContext';
export function SiteComponent(_a) {
    var { id, plugin, component, children } = _a, props = __rest(_a, ["id", "plugin", "component", "children"]);
    // register the plugin and component in the site context
    const siteContext = useSiteContext();
    const { openedDialogEvents, plugins, siteComponentMap } = siteContext;
    const siteContextRef = useRef(siteContext);
    const { isIframe } = useIframeMessageContext();
    component = component
        ? siteComponentMap[component.id] || component
        : component;
    // remove functions that can't be transmitted
    const cleanedProps = Object.assign({}, props);
    Object.keys(cleanedProps).forEach(key => {
        if (typeof cleanedProps[key] === 'function') {
            delete cleanedProps[key];
        }
    });
    const componentRef = useRef(component
        ? Object.assign(Object.assign({}, component), { props: Object.assign(Object.assign({}, component.props), cleanedProps) }) : {
        id: id,
        name: plugin.name,
        type: plugin.type,
        depth: 0,
        position: 0,
        props: cleanedProps
    });
    // const elementRef = useRef<HTMLElement>();
    useEffect(() => {
        // plugin initialization
        let component = componentRef.current;
        const plugin = plugins.find(p => p.type === component.type);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.init) {
            componentRef.current = plugin.init(componentRef.current, siteContextRef.current);
            component = componentRef.current;
        }
    }, [component === null || component === void 0 ? void 0 : component.id, component === null || component === void 0 ? void 0 : component.type, plugins, isIframe]);
    // only get dialogs for this component
    const renderDialogEvents = useMemo(() => {
        return openedDialogEvents.filter(events => events.componentId === (component === null || component === void 0 ? void 0 : component.id));
    }, [component === null || component === void 0 ? void 0 : component.id, openedDialogEvents]);
    return (React.createElement(QueryProvider, null,
        children,
        renderDialogEvents.map((event, index) => (React.createElement(event.plugin.component, Object.assign({ component: event.dialog, key: `${event.dialog.id}-${index}` }, (event.dialog.props || {}), { "$openDialogEvent": event }))))));
}
//# sourceMappingURL=SiteComponentPlugin.js.map